import { DonutChart, Legend } from "@tremor/react";
import ExportToCsv from "./ExportDataIntoExcel";
import { useTranslation } from 'react-i18next';
import { Chart } from 'primereact/chart';

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const generateRandomColors = (numColors) => {
  const colors = [];
  for (let i = 0; i < numColors; i++) {
    colors.push(getRandomColor());
  }
  return colors;
};

const PieChart = ({ chartData, getDRDTooltip }) => {
  const { title, data = [], chartType = "pie", excelData } = chartData || {};
  const {t}=useTranslation();
  const DRAG_AND_DROP=t("DRAG_AND_DROP")
  return (
    <>
      <div className="flex gap-3 align-items-center">
        {getDRDTooltip("drd-pie-chart", DRAG_AND_DROP)}
        {/* <ExportToCsv jsonData={excelData} filename={"PieChartData.csv"} /> */}
      </div>
      <div className="mx-auto space-y-12 pie-chart">
        <div className="flex flex-column" style={{ gap: '10px' }}>
          <label className="font-bold flex justify-content-center">
            {title}
          </label>
          <div className="flex justify-center flex-column">
          <Chart
            type={chartType}
            data={{
              labels: data.map(d => d.name),
              datasets: [
                {
                  data: data.map(d => d.value),
                  backgroundColor: generateRandomColors(data.length),
                  hoverBackgroundColor: generateRandomColors(data.length),
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
      aspectRatio: 0.5,
              plugins: {
                legend: {
                  display: false,
                  labels: {
                    usePointStyle: false,
                  },
                },
              },
            }}
            // className="w-full md:w-30rem"
          />
          </div>
        </div>
      </div>
    </>
  );
};

export default PieChart;
